<template>
  <Article fluid />
</template>
<script>
import Article from '@/components/common/layout/Article.vue'

export default {
  name: 'DefaultLayoutFluid',
  components: {
    Article,
  },
}
</script>
